import React, { useContext, useEffect, useState } from "react";
import Logo from "../../../assets/images/Logo-bg.png";
import LogoWhite from "../../../assets/images/Logo-bg.png";
import smallLogo from "../../../assets/images/Logo-bg.png";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../../hooks/MyContextProvider";
const ToggleSwitch = React.lazy(() =>
  import("../../../Component/ToggleSwitch")
);

const Header = () => {
  const navigate = useNavigate();
  const {
    theme,
    updateClient,
    updateAdminToken,
    clientDetails,
    isMenuExpanded,
    setIsMenuExpanded,
  } = useContext(MyContext);
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const profileDropdown = document.getElementById("profile-dropdown");
      if (profileDropdown && !profileDropdown.contains(event.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav
      class="layout-navbar navbar navbar-expand-xl align-items-center"
      id="layout-navbar"
      style={{
        backgroundColor: theme === "dark" ? "#2f3349" : "#fff",
      }}
    >
      <div class="container-fluid">
        <div class="navbar-brand app-brand demo d-none d-xl-flex py-0 me-4 ms-0">
          <Link to="/administration" class="app-brand-link">
            <span class="app-brand-logo demo">
              <span class="text-primary">
                <img
                  src={theme === "dark" ? LogoWhite : Logo}
                  alt="Logo"
                  height="44"
                />
              </span>
            </span>
          </Link>

          <Link
            class="layout-menu-toggle menu-link text-large ms-auto d-xl-none"
            onClick={() => setIsMenuExpanded(!isMenuExpanded)}
          >
            <i class="icon-base ti tabler-x icon-sm d-flex align-items-center justify-content-center"></i>
          </Link>
        </div>

        <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <Link
            class="nav-item nav-link px-0 me-xl-6"
            onClick={() => setIsMenuExpanded(!isMenuExpanded)}
          >
            <i class="icon-base ti tabler-menu-2 icon-md"></i>
          </Link>
        </div>

        <div
          class="navbar-nav-right d-flex align-items-center justify-content-end"
          id="navbar-collapse"
        >
          <ul class="navbar-nav flex-row align-items-center ms-md-auto">
            <li class="nav-item">
              <ToggleSwitch />
            </li>

            <li class="mx-3 nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2">
              <Link
                class="nav-link dropdown-toggle hide-arrow btn btn-icon btn-text-secondary rounded-pill waves-effect"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <span class="position-relative">
                  <i class="icon-base ti tabler-bell icon-22px text-heading"></i>
                  <span class="badge rounded-pill bg-danger badge-dot badge-notifications border"></span>
                </span>
              </Link>
              <ul class="dropdown-menu dropdown-menu-end p-0">
                <li class="dropdown-menu-header border-bottom">
                  <div class="dropdown-header d-flex align-items-center py-3">
                    <h6 class="mb-0 me-auto">Notification</h6>
                    <div class="d-flex align-items-center h6 mb-0">
                      <span class="badge bg-label-primary me-2">8 New</span>
                      <a
                        href="javascript:void(0)"
                        class="dropdown-notifications-all p-2 btn btn-icon waves-effect waves-light"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        aria-label="Mark all as read"
                        data-bs-original-title="Mark all as read"
                      >
                        <i class="icon-base ti tabler-mail-opened text-heading"></i>
                      </a>
                    </div>
                  </div>
                </li>
                <li class="dropdown-notifications-list scrollable-container ps">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/1.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="small mb-1">Congratulation Lettie 🎉</h6>
                          <small class="mb-1 d-block text-body">
                            Won the monthly best seller gold badge
                          </small>
                          <small class="text-body-secondary">1h ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span class="avatar-initial rounded-circle bg-label-danger">
                              CF
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">Charles Franklin</h6>
                          <small class="mb-1 d-block text-body">
                            Accepted your connection
                          </small>
                          <small class="text-body-secondary">12hr ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/2.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">New Message ✉️</h6>
                          <small class="mb-1 d-block text-body">
                            You have new message from Natalie
                          </small>
                          <small class="text-body-secondary">1h ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span class="avatar-initial rounded-circle bg-label-success">
                              <i class="icon-base ti tabler-shopping-cart"></i>
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Whoo! You have new order 🛒
                          </h6>
                          <small class="mb-1 d-block text-body">
                            ACME Inc. made new order $1,154
                          </small>
                          <small class="text-body-secondary">1 day ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/9.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Application has been approved 🚀
                          </h6>
                          <small class="mb-1 d-block text-body">
                            Your ABC project application has been approved.
                          </small>
                          <small class="text-body-secondary">2 days ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span class="avatar-initial rounded-circle bg-label-success">
                              <i class="icon-base ti tabler-chart-pie"></i>
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Monthly report is generated
                          </h6>
                          <small class="mb-1 d-block text-body">
                            July monthly financial report is generated
                          </small>
                          <small class="text-body-secondary">3 days ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/5.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">Send connection request</h6>
                          <small class="mb-1 d-block text-body">
                            Peter sent you connection request
                          </small>
                          <small class="text-body-secondary">4 days ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/6.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">New message from Jane</h6>
                          <small class="mb-1 d-block text-body">
                            Your have new message from Jane
                          </small>
                          <small class="text-body-secondary">5 days ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span class="avatar-initial rounded-circle bg-label-warning">
                              <i class="icon-base ti tabler-alert-triangle"></i>
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">CPU is running high</h6>
                          <small class="mb-1 d-block text-body">
                            CPU Utilization Percent is currently at 88.63%,
                          </small>
                          <small class="text-body-secondary">5 days ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                          >
                            <span class="badge badge-dot"></span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                          >
                            <span class="icon-base ti tabler-x"></span>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                    <div
                      class="ps__thumb-x"
                      tabindex="0"
                      style={{ left: 0, width: 0 }}
                    ></div>
                  </div>
                  <div class="ps__rail-y" style={{ top: 0, right: 0 }}>
                    <div
                      class="ps__thumb-y"
                      tabindex="0"
                      style={{ top: 0, height: 0 }}
                    ></div>
                  </div>
                </li>
                <li class="border-top">
                  <div class="d-grid p-4">
                    <a
                      class="btn btn-primary btn-sm d-flex waves-effect waves-light"
                      href="javascript:void(0);"
                    >
                      <small class="align-middle">View all notifications</small>
                    </a>
                  </div>
                </li>
              </ul>
            </li>

            <li class="nav-item navbar-dropdown dropdown-user dropdown">
              <Link
                class="nav-link dropdown-toggle hide-arrow p-0"
                data-bs-toggle="dropdown"
                onClick={() => setShowProfile(true)}
                style={{ cursor: "pointer" }}
              >
                <div class="avatar avatar-online">
                  <img src={smallLogo} alt="" class="rounded-circle" />
                </div>
              </Link>
              <ul
                class={`dropdown-menu dropdown-menu-end  ${
                  showProfile ? "show" : ""
                }`}
                id="profile-dropdown"
                style={{ left: "auto", right: "0" }}
              >
                <li>
                  <Link class="dropdown-item mt-0 waves-effect">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-2">
                        <div class="avatar avatar-online">
                          <img src={smallLogo} alt="" class="rounded-circle" />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-0">{clientDetails.name}</h6>
                        <small class="text-body-secondary">Admin</small>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <div class="dropdown-divider my-1 mx-n2"></div>
                </li>
                <li>
                  <Link
                    class="dropdown-item waves-effect"
                    to={"/administration/profile"}
                  >
                    <i class="icon-base ti tabler-user me-3 icon-md"></i>
                    <span class="align-middle">My Profile</span>
                  </Link>
                </li>
                <li>
                  <div class="d-grid px-2 pt-2 pb-1">
                    <Link
                      class="btn btn-sm btn-danger d-flex waves-effect waves-light"
                      onClick={() => {
                        localStorage.clear();
                        updateClient({});
                        updateAdminToken("");
                        navigate("/administration");
                      }}
                    >
                      <small class="align-middle">Logout</small>
                      <i class="icon-base ti tabler-logout ms-2 icon-14px"></i>
                    </Link>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
